var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from 'styled-components';
import { VariantButton } from './VariantButton';
export var PrimaryButton = styled(VariantButton).attrs(function (_a) {
  var _b, _c, _d;

  var theme = _a.theme;
  return {
    $variantStyles: (_d = (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.splash) === null || _b === void 0 ? void 0 : _b.button) === null || _c === void 0 ? void 0 : _c.variants) === null || _d === void 0 ? void 0 : _d.primary
  };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;